import React from "react";
import "../../css/ShoppingCart.css";
import { useDispatch } from "react-redux";
import { removeFromCart, updateCartItem } from "../../redux/actions";

const ShoppingCartOrder = ({ item }) => {
  const dispatch = useDispatch();
  const { id, name, price, quantity } = item;

  const handleIncrement = () => {
    dispatch(updateCartItem(id, quantity + 1));
  };

  const handleDecrement = () => {
    const newQty = quantity - 1;
    if (newQty <= 0) {
      dispatch(removeFromCart(id));
    } else {
      dispatch(updateCartItem(id, newQty));
    }
  };

  return (
    <div className="cart-product">
      <div>
        <div className="cart-product-name">{name}</div>
        <div className="cart-product-qty-controls">
          <button onClick={handleDecrement} className="qty-button">
            -
          </button>
          <span className="qty-count">x{quantity}</span>
          <button onClick={handleIncrement} className="qty-button">
            +
          </button>
        </div>
      </div>
      <div className="cart-product-controls">
        <span className="cart-product-price">
          ${(price * quantity).toFixed(2)}
        </span>
        <button
          className="cart-product-remove"
          onClick={() => dispatch(removeFromCart(id))}
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default ShoppingCartOrder;
